import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { ApiResources } from '../../enums/api-resources';
import { PagedResourcesRS, ResourceSearchParams } from '../../models/resources/resources-response';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  constructor(private http:HttpClient) { }

  //upload resources
  uploadResource(fileData: FormData) {
    let url = environment.baseUrl + ApiResources.UPLOAD_FILE;
    let headers = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url, fileData, { headers: headers });
  }

  //upload resources SYNC
  uploadResourceSync(fileData: FormData) {
    let url = environment.baseUrl + ApiResources.UPLOAD_FILE_SYNC;
    let headers = new HttpHeaders({
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url, fileData, { headers: headers });
  }

  deleteResource(id:string){
    let url = environment.baseUrl + ApiResources.UPLOAD_FILE + '/' + id;
    let headers = new HttpHeaders({
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.delete(url,  { headers: headers });
  }

  /**
   * Biblioteca de medios: lista paginada de los ficheros de la tienda.
   *
   * Sin `siteId` el backend devuelve los de todas las tiendas del usuario.
   * Solo se envian los parametros con valor, para no mandar `undefined` como texto.
   */
  searchResources(params: ResourceSearchParams = {}) {
    const url = environment.baseUrl + ApiResources.SEARCH_RESOURCES;
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });

    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.http.get<PagedResourcesRS>(url, { headers, params: httpParams });
  }

  //get file object 
  getFileObject(fileurl){
   
    return this.http.get(fileurl, {responseType: "blob"});
  }
}
